import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Container, Offcanvas, Navbar, Nav, Image } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import * as Icon from 'react-feather';

import axios from 'axios';
import { host } from '../../function/api'
import avatar from '../../assets/media/image/avatar.png'
import logoF from '../../assets/media/image/KAVIR-RGB.png'
import logoLight from '../../assets/media/image/KAVIR-RGB.png'
function NavbarAgent(props) {
    // const dataMenu = JSON.parse(localStorage.getItem('menuList'))

    const [menuData, setMenuData] = useState()
    const [planStatus, setPlanStatus] = useState({})
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const [message, setMessage] = useState('');

    const loading = useSelector(state => state.navbar.loading)
    const menus = {
        
    }

    const {username} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []
    
    const [show, setShow] = useState(false);

    const offsetValue = -56;
  
    const toggleOffCanvas = (e) => {
        // e.preventDefault()
      setShow((show) => !show);
      localStorage.setItem('access', e.target.id)
    };
    
    const signOutHandler = () => {
        localStorage.removeItem('token')
        window.location.reload(true)
    }

    const refresh = () => {
        window.location.reload(true)
    }

    const rahpardaznet_plan_status = async () => {
        try {
            setPlanStatus({});
            if(token){
                const response = await axios({
                    method: 'GET',
                    url: `${host}agent/plan/status`,
                    headers: {
                        'Accept': 'application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
    
                })
                if (response.data.status === true) {
                    setPlanStatus(response.data.data);
                }
            }
            
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
            })
        }
    }
    useEffect(() => {
        setPlanStatus({});
        rahpardaznet_plan_status();
    },[])
    
    return (
        <>


            <div className="header">

                <div>
                    <ul className="navbar-nav">


                        <li className="nav-item navigation-toggler mobile-toggler">
                            <a href="#" className="nav-link" title="Show navigation">
                                {/* <i data-feather="menu"></i> */}
                                <Icon.Menu/>
                            </a>
                        </li>
                        <li className="nav-item d-block rahpardaznet-username-avatar">
                        <span className="bold">{username}</span> عزیز خوش آمدید.
                        </li>


                    </ul>
                </div>

                <div>
                    <ul className="navbar-nav">


                        <li className="nav-item dropdown">
                            <a href="#" className="nav-link" title="تمام صفحه" data-toggle="fullscreen">
                                {/* <i className="maximize" data-feather="maximize"></i> */}
                                {/* <i className="minimize" data-feather="minimize"></i> */}
                                <Icon.Maximize className="maximize"/>
                                <Icon.Minimize className="minimize"/>
                            </a>
                        </li>


                        <li className="nav-item dropdown">
                            {/*<a href="#" className="nav-link nav-link-notify" title="اطلاعیه‌ها" data-toggle="dropdown">*/}
                            {/*    /!* <i data-feather="bell"></i> *!/*/}
                            {/*    <Icon.Bell />*/}
                            {/*</a>*/}
                            <div className="dropdown-menu dropdown-menu-left dropdown-menu-big">
                                <div className="p-4 text-center d-flex justify-content-between"
                                     data-backround-image="assets/media/image/image1.jpg">
                                    <h6 className="mb-0">اطلاعیه‌ها</h6>
                                    <small className="font-size-11 opacity-7">1 اطلاعیه خوانده نشده</small>
                                </div>
                                <div>
                                    <ul className="list-group list-group-flush">
                                        <li>
                                            <a href="#" className="list-group-item d-flex hide-show-toggler">
                                                <div>
                                                    <figure className="avatar avatar-sm m-r-15">
                                                        <span
                                                            className="avatar-title bg-success-bright text-success rounded-circle">
                                                            <i className="ti-user"></i>
                                                        </span>
                                                    </figure>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <p className="mb-0 line-height-20 d-flex justify-content-between">
                                                        ثبت نام خریدار جدید
                                                        <i title="Mark as read" data-toggle="tooltip"
                                                           className="hide-show-toggler-item fa fa-circle-o font-size-11"></i>
                                                    </p>
                                                    <span className="text-muted small">20 دقیقه قبل</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li className="text-divider small pb-2 pl-3 pt-3">
                                            <span>اطلاعیه‌های قبلی</span>
                                        </li>
                                        <li>
                                            <a href="#" className="list-group-item d-flex hide-show-toggler">
                                                <div>
                                                    <figure className="avatar avatar-sm m-r-15">
                                                        <span
                                                            className="avatar-title bg-warning-bright text-warning rounded-circle">
                                                            <i className="ti-package"></i>
                                                        </span>
                                                    </figure>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <p className="mb-0 line-height-20 d-flex justify-content-between">
                                                        سفارش جدید دریافت شد
                                                        <i title="Mark as unread" data-toggle="tooltip"
                                                           className="hide-show-toggler-item fa fa-check font-size-11"></i>
                                                    </p>
                                                    <span className="text-muted small">45 ثانیه قبل</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#"
                                               className="list-group-item d-flex align-items-center hide-show-toggler">
                                                <div>
                                                    <figure className="avatar avatar-sm m-r-15">
                                                        <span
                                                            className="avatar-title bg-danger-bright text-danger rounded-circle">
                                                            <i className="ti-server"></i>
                                                        </span>
                                                    </figure>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <p className="mb-0 line-height-20 d-flex justify-content-between">
                                                        به سقف مجاز سرور نزدیک شده اید
                                                        <i title="Mark as unread" data-toggle="tooltip"
                                                           className="hide-show-toggler-item fa fa-check font-size-11"></i>
                                                    </p>
                                                    <span className="text-muted small">55 ثانیه قبل</span>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#"
                                               className="list-group-item d-flex align-items-center hide-show-toggler">
                                                <div>
                                                    <figure className="avatar avatar-sm m-r-15">
                                                        <span
                                                            className="avatar-title bg-info-bright text-info rounded-circle">
                                                            <i className="ti-layers"></i>
                                                        </span>
                                                    </figure>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <p className="mb-0 line-height-20 d-flex justify-content-between">
                                                        اپ های دارای بروزسانی
                                                        <i title="Mark as unread" data-toggle="tooltip"
                                                           className="hide-show-toggler-item fa fa-check font-size-11"></i>
                                                    </p>
                                                    <span className="text-muted small">دیروز</span>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="p-2 text-right">
                                    <ul className="list-inline small">
                                        <li className="list-inline-item">
                                            <a href="#">علامتگذاری به عنوان خوانده شده</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>

                        <li className="nav-item dropdown">
                            {/*<a href="#" className="nav-link" title="User menu" data-toggle="dropdown">*/}
                            {/*    /!* <i data-feather="settings"></i> *!/*/}
                            {/*    <Icon.Settings />*/}
                            {/*</a>*/}
                            <div className="dropdown-menu dropdown-menu-left dropdown-menu-big">
                                <div className="p-4 text-center d-flex justify-content-between"
                                     data-backround-image="assets/media/image/image1.jpg">
                                    <h6 className="mb-0">تنظیمات</h6>
                                </div>
                                <div>
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="customSwitch1" checked/>
                                                <label className="custom-control-label" htmlhtmlFor="customSwitch1">مجوز
                                                    ارسال اطلاعیه</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="customSwitch2"/>
                                                <label className="custom-control-label" htmlhtmlFor="customSwitch2">پنهان
                                                    کردن درخواست ها</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="customSwitch3" checked/>
                                                <label className="custom-control-label" htmlhtmlFor="customSwitch3">افزایش
                                                    سرعت انجام دستورات</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="customSwitch4" checked/>
                                                <label className="custom-control-label" htmlhtmlFor="customSwitch4">پنهان
                                                    کردن منو</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="customSwitch5"/>
                                                <label className="custom-control-label" htmlhtmlFor="customSwitch5">به
                                                    خاطرسپاری بازدید</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" className="custom-control-input"
                                                       id="customSwitch6"/>
                                                <label className="custom-control-label" htmlhtmlFor="customSwitch6">فعالسازی
                                                    تولید گزارش خودکار</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <ul className="navbar-nav d-flex align-items-center">
                        <li className="nav-item header-toggler">
                            <a href="#" className="nav-link">
                                {/* <i data-feather="arrow-down"></i> */}
                                <Icon.ArrowDown/>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>
            <div className="navigation">



                <div className="navigation-menu-body">

                    <div>
                        <div id="navigation-logo">
                            <a href="index.html">
                                <img className="logo" src={logoF} alt="logo"/>
                                <img className="logo-light" src={logoLight} alt="light logo"/>
                            </a>
                        </div>
                    </div>

                    <div className="navigation-menu-group">
                        <ul>
                            <li className="rahpardaznet-agent-menu-item">
                                 <Link
                                    activeClassName="active"
                                    aria-current="page"
                                    to="/agent"
                                >
                                    داشبورد من
                                </Link>
                            </li>
                            <li className="rahpardaznet-agent-menu-item">
                                <NavLink
                                    activeClassName="active"
                                    onClick={toggleOffCanvas}
                                    to='/agent/request/create'>
                                    ثبت درخواست جدید
                                </NavLink>
                            </li>
                            <li className="rahpardaznet-agent-menu-item">
                                <NavLink
                                    activeClassName="active"
                                    onClick={toggleOffCanvas}
                                    to='/agent/requests'>
                                    لیست درخواست ها
                                </NavLink>
                            </li>
                            <li className="rahpardaznet-agent-menu-item">
                                <NavLink
                                    activeClassName="active"
                                    onClick={toggleOffCanvas}
                                    to='/agent/plans'>
                                    اشتراک  
                                </NavLink>
                            </li>

                            <li className="rahpardaznet-agent-menu-item">
                                <Link
                                    onClick={signOutHandler}
                                    to='/'>
                                    خروج
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {
                (typeof planStatus === 'object' && Object.keys(planStatus).length != 0 && planStatus.count_request > 0 && planStatus.count_date > 0) ? (

                    <>
                        <div className='rahpardaznet-plan-status success'>
                            اشتراک شما فعال است.
                        </div>
                    </>

                ) : null
            }


{
                (Object.keys(planStatus).length == 0 || planStatus.count_request == 0 || planStatus.count_date == 0) ? (

                    <>
                        <div className='rahpardaznet-plan-status danger'>
                            شما اشتراک فعالی ندارید.
                        </div>
                    </>

                ) : null
            }
                </div>

            </div>
        </>
    )
}
export default NavbarAgent;